<template>
	<div class="basic-container popup">
		<div class="popup-address-area">
			<section>
				<div class="block" v-for="(row, i) in matchUserList" :key="'matchUserList_' + i">
					<div @click="choiceUser(row)">
						<input
							class="close-btn"
							:class="selectRow === row.userSeqNo ? 'selected' : ''"
							type="text"
							v-if="isCompany"
							disabled
							:value="row.countryNm + ' / ' + row.regionNm + ' ' + row.oktaUserNmKor"
						/>
						<input
							class="close-btn"
							:class="selectRow === row.companySeqNo ? 'selected' : ''"
							type="text"
							v-else
							disabled
							:value="row.companyNmKor"
						/>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import CONST from '@/constants';
import eventBus from '@/plugins/event-bus';

export default {
	title: '쪽지쓰기주소록',
	name: 'PopupAddress',
	props: [],
	components: {},
	data: function() {
		return {
			CONST,
			loginMember: null,
			matchUserList: [],
			selectRow: 0,
		};
	},
	watch: {},
	created() {},
	computed: {
		isCompany() {
			return this.loginMember && this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY;
		},
	},
	mounted() {
		this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'INBOX');
		let dt = this.$device.loadLocalData('LOGIN_USER');
		if (dt) this.loginMember = JSON.parse(dt);
		this.getMatchUserList();
	},
	beforeDestroy() {},
	methods: {
		choiceUser: function(row) {
			if (this.isCompany) {
				this.selectRow = row.userSeqNo;
			} else {
				this.selectRow = row.companySeqNo;
			}
			eventBus.$emit(CONST.EVENTS.DATA_RETURN, 'modalAddress', row);
			eventBus.$emit(CONST.EVENTS.CLOSE_MODAL);
		},
		getMatchUserList: function() {
			this.matchUserList = [];
			let formData = new FormData();
			formData.append('businessYear', this.$moment().format('YYYY'));
			if (this.isCompany) {
				formData.append('companySeqNo', this.loginMember.seqNo);
			} else {
				formData.append('userSeqNo', this.loginMember.seqNo);
			}
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/common/getMatchUserList.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						this.matchUserList = res.data.data;
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
	},
};
</script>

<style scoped></style>
